
export default function MarketInefficiency() {
  const gaps = [
    'No chatbot or conversational interface',
    'Outdated or static websites',
    'Missed inbound calls',
    'No automated follow-up',
    'No AI-based lead qualification',
  ];

  return (
    <section className="py-24 px-6 lg:px-8">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-16">
          <p className="text-sm uppercase tracking-[0.2em] text-[#0EA5E9] font-semibold mb-4">
            Market Inefficiency
          </p>
          <h2 className="text-4xl md:text-5xl font-bold">
            Revenue Leakage <span className="text-[#0EA5E9]">Opportunity</span>
          </h2>
        </div>

        <div className="space-y-10">
          <p className="text-lg text-gray-300 leading-relaxed">
            Across the U.S., millions of service businesses operate with limited digital infrastructure.
          </p>

          <div>
            <p className="text-lg text-white font-semibold mb-5">Common gaps include:</p>
            <ul className="space-y-3">
              {gaps.map((gap, index) => (
                <li key={index} className="flex items-start space-x-3">
                  <span className="mt-2 w-1.5 h-1.5 rounded-full bg-[#0EA5E9] flex-shrink-0" />
                  <span className="text-gray-300 text-lg">{gap}</span>
                </li>
              ))}
            </ul>
          </div>

          <p className="text-lg text-gray-300 leading-relaxed">
            For high-ticket verticals such as legal, dental, solar, and local service operators, a single missed call can represent <strong className="text-white">$500 to $10,000</strong> in lost revenue.
          </p>

          <p className="text-lg text-gray-300 leading-relaxed">
            Despite this, a large percentage of these businesses remain under-automated.
          </p>

          <p className="text-lg text-white font-semibold">
            This creates a measurable revenue leakage gap.
          </p>

          <div className="border-l-2 border-[#0EA5E9]/40 pl-6 space-y-6">
            <p className="text-lg text-gray-300 leading-relaxed">
              AiConnect is positioned to address this inefficiency.
            </p>

            <p className="text-lg text-gray-300 leading-relaxed">
              Rather than relying on traditional sales pressure, the model deploys a <strong className="text-white">live 5-day infrastructure demonstration</strong>. Businesses experience real-time lead capture, automation, and engagement before committing.
            </p>
          </div>

          <p className="text-lg text-white font-semibold">
            The lift is immediate.
          </p>

          <p className="text-lg text-gray-300 leading-relaxed">
            Conversion becomes performance-driven rather than persuasion-driven.
          </p>

          <p className="text-lg text-gray-300 leading-relaxed">
            Voice AI and deeper workflow automation are layered post-adoption, expanding recurring revenue per account.
          </p>
        </div>
      </div>
    </section>
  );
}
